import { styled } from 'styled-components'

import { Select } from 'core/components'

export const Box = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`

export const StyledSelect = styled(Select)`
  width: 248px;
`

export const SubLabel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-transform: lowercase;
  color: ${(props) => props.theme.disabled};
  font-size: 10px;

  span:last-child {
    text-transform: uppercase;
  }
`

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 16px;
  padding-bottom: 24px;
`
